import { createContext, useCallback, useContext, useEffect, useState } from "react";

const WalletContext = createContext(null);
export const useWallet = () => useContext(WalletContext);

export function getProviders() {
  if (typeof window === "undefined") return [];
  const found = [];
  const push = (name, provider) => {
    if (provider && typeof provider.connect === "function" && typeof provider.signAndSendTransaction === "function" && !found.some((w) => w.provider === provider)) {
      found.push({ name, provider });
    }
  };
  if (window.phantom?.solana) push("Phantom", window.phantom.solana);
  if (window.solflare) push("Solflare", window.solflare);
  if (window.solana) push(window.solana.isPhantom ? "Phantom" : "Solana wallet", window.solana);
  return found;
}

export function WalletProvider({ children }) {
  const [wallets, setWallets] = useState([]);
  const [wallet, setWallet] = useState(null);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    const detect = () => setWallets(getProviders());
    detect();
    const t = setInterval(detect, 800);
    const stop = setTimeout(() => clearInterval(t), 8000);
    return () => {
      clearInterval(t);
      clearTimeout(stop);
    };
  }, []);

  const connect = useCallback(async (w) => {
    const target = w || getProviders()[0];
    if (!target) throw new Error("No Solana wallet detected — install Phantom to continue");
    const res = await target.provider.connect();
    const pub = res?.publicKey?.toString?.() || target.provider?.publicKey?.toString?.();
    if (!pub) throw new Error("Wallet did not return a public key");
    setWallet(target);
    setAddress(pub);
    return pub;
  }, []);

  const disconnect = useCallback(async () => {
    try {
      await wallet?.provider?.disconnect?.();
    } catch (e) {
      // ignore
    }
    setWallet(null);
    setAddress(null);
  }, [wallet]);

  return (
    <WalletContext.Provider value={{ wallets, wallet, address, connect, disconnect }}>
      {children}
    </WalletContext.Provider>
  );
}
